<template>
  <div id="index_five">
    <u-animate-container>
      <div class="top">
        <div
          class="item"
          @click="
            {
              $router.push({
                path: `/solution/5`
              });
            }
          "
        >
          <u-animate
            class="title"
            name="fadeInRight"
            delay="0s"
            duration="1s"
            :iteration="1"
            :offset="0"
            animateClass="animated"
            :begin="false"
          >
            <div class="title_en">
              {{ locale !== "zh-cn" ? "汽车结构" : "AUTOMOBILE STRUCTURE" }}
            </div>
            <div class="title_cn">
              {{ locale === "zh-cn" ? "汽车结构" : "AUTOMOBILE STRUCTURE" }}
            </div>
          </u-animate>
          <img src="@/assets/images/capstructure.png" />
        </div>
        <div
          class="item"
          @click="
            {
              $router.push({
                path: `/solution/6`
              });
            }
          "
        >
          <u-animate
            class="title"
            name="fadeInRight"
            delay="0.5s"
            duration="1s"
            :iteration="1"
            :offset="0"
            animateClass="animated"
            :begin="false"
          >
            <div class="title_en">
              {{
                locale !== "zh-cn"
                  ? "最大射电望远镜"
                  : "“FAST” - LARGEST RADIO TELESCOPE"
              }}
            </div>
            <div class="title_cn">
              {{
                locale === "zh-cn"
                  ? "最大射电望远镜"
                  : "“FAST” - LARGEST RADIO TELESCOPE"
              }}
            </div>
          </u-animate>
          <img src="@/assets/images/radiotelescope.png" />
        </div>
      </div>
      <div class="bottom">
        <div
          class="item"
          @click="
            {
              $router.push({
                path: '/news'
              });
            }
          "
        >
          <u-animate
            class="title"
            name="fadeInRight"
            delay="0s"
            duration="1s"
            :iteration="1"
            :offset="0"
            animateClass="animated"
            :begin="false"
          >
            <!-- <div class="title_en">
              {{
                locale !== "zh-cn" ? "公司动态" : "ACTIVE NEWS OF THE COMPANY"
              }}
            </div>
            <div class="title_cn">
              {{
                locale === "zh-cn" ? "公司动态" : "ACTIVE NEWS OF THE COMPANY"
              }}
            </div> -->
          </u-animate>
          <img src="@/assets/images/companypress.png" />
        </div>
        <div
          class="item"
          @click="
            {
              $router.push({
                path: '/product/0'
              });
            }
          "
        >
          <u-animate
            class="title"
            name="fadeInRight"
            delay="0.5s"
            duration="1s"
            :iteration="1"
            :offset="0"
            animateClass="animated"
            :begin="false"
          >
            <div class="title_en">
              {{ locale !== "zh-cn" ? "特殊产品" : "SPECIAL PRODUCT" }}
            </div>
            <div class="title_cn">
              {{ locale === "zh-cn" ? "特殊产品" : "SPECIAL PRODUCT" }}
            </div>
          </u-animate>
          <img src="@/assets/images/specialproduct.png" />
        </div>
        <div class="item">
          <u-animate
            class="title"
            name="fadeInRight"
            delay="1s"
            duration="1s"
            :iteration="1"
            :offset="0"
            animateClass="animated"
            :begin="false"
          >
            <!-- <div class="title_en">
              {{ locale !== "zh-cn" ? "检测设备" : "TESTING MACHINES" }}
            </div>
            <div class="title_cn">
              {{ locale === "zh-cn" ? "检测设备" : "TESTING MACHINES" }}
            </div> -->
          </u-animate>
          <img src="@/assets/images/checkequipment.png" />
        </div>
      </div>
    </u-animate-container>
  </div>
</template>

<script>
import { UAnimateContainer, UAnimate } from "vue-wow";
export default {
  components: {
    UAnimateContainer,
    UAnimate
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    }
  },
  methods: {
    handleClick(id) {
      this.$router.push({
        path: `/solution/${id}`
      });
    }
  }
};
</script>

<style scoped lang="scss">
#index_five {
  width: 1140px;
  margin: 60px auto;
  height: auto;
  overflow: hidden;
  .top {
    height: 350px;
    width: 100%;
    .item {
      width: 550px;
      height: 300px;
      margin-right: 40px;
      &:nth-of-type(1) {
        background: #000;
      }
      &:nth-of-type(2) {
        background: #193765;
      }
      img {
        width: 550px;
        height: 300px;
      }
    }
  }
  .bottom {
    height: 350px;
    width: 100%;
    .item {
      width: 350px;
      height: 300px;
      margin-right: 40px;
      &:nth-of-type(1) {
        background: #2f687c;
      }
      &:nth-last-of-type(1),
      &:nth-last-of-type(2) {
        .title_cn {
          color: #000;
        }
        &:nth-last-of-type(1) {
          background: #d7d1d3;
        }
        &:nth-last-of-type(2) {
          background: #e8e8e7;
        }
      }
      img {
        width: 100%;
        height: 300px;
      }
    }
  }
  .item {
    position: relative;
    float: left;
    &:last-of-type {
      margin-right: 0;
    }
    img {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }
    .title {
      position: absolute;
      top: 30px;
      left: 30px;
      z-index: 2;
      .title_en {
        font-size: 0.13rem;
        color: #fd8204;
      }
      .title_cn {
        font-size: 0.22rem;
        color: #fff;
        font-weight: bold;
        margin-top: 5px;
        letter-spacing: 1px;
      }
    }
  }
}
@media screen and (max-width: 750px) {
  #index_five {
    width: 100%;
    margin: 0px auto;
    .top {
      height: auto;
      .item {
        width: 100%;
        height: 240px;
        margin-bottom: 10px;
        img {
          width: 100%;
          height: 240px;
        }
      }
    }
    .bottom {
      height: auto;
      .item {
        margin-right: 0;
        width: 100%;
        height: 240px;
        margin-bottom: 10px;
        overflow: hidden;
      }
    }
    .item {
      .title {
        .title_en {
          font-size: 0.8rem;
        }
        .title_cn {
          font-size: 1.2rem;
          margin-top: 10px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/components/Index/IndexFive.vue